import AdministratorsRoutes from 'App/administrators/routes';
import CustumerRoutes from 'App/customers/routes';
import ContratacoesRoutes from 'App/contratacoes/routes';
import CompaniesRoutes from 'App/companies/routes';
import ProfileRoutes from 'App/profile/routes';
import UseTermsRoutes from 'App/useterms/routes';
import ParametersRoutes from 'App/parameters/routes';
import HolidaysRoutes from 'App/holidays/routes';
import FinancialRoutes from 'App/financial/routes';
import GenerateMessagesRoutes from 'App/generate-messages/routes';
import TecfinOfferRoutes from 'App/tecfin-offer/routes';
import ModalitiesRoutes from 'App/modalities/routes';
import Loans from 'App/loans/routes';
import Reports from 'App/reports/routes';
import Communication from 'App/communication/routes';

export default [
  {
    path: '/',
    component: () => import('Support/layout/Layout.vue'),
    children: [
      ...AdministratorsRoutes,
      ...CustumerRoutes,
      ...ParametersRoutes,
      ...UseTermsRoutes,
      ...ProfileRoutes,
      ...CompaniesRoutes,
      ...ContratacoesRoutes,
      ...HolidaysRoutes,
      ...FinancialRoutes,
      ...GenerateMessagesRoutes,
      ...TecfinOfferRoutes,
      ...ModalitiesRoutes,
      ...Loans,
      ...Reports,
      ...Communication,
    ],
  },
  {
    path: '/login',
    component: () => import('App/login/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('App/login/components/Login.vue'),
      },
      {
        path: 'first-access',
        name: 'FirstAccess',
        component: () => import('App/login/components/FirstAccess.vue'),
      },
      {
        path: 'first-access/success',
        name: 'FirstAccessSuccess',
        component: () => import('App/login/components/FirstAccessSuccess.vue'),
      },
      {
        path: 'recover',
        name: 'RecoverPassword',
        component: () => import('App/login/components/RecoverPassword.vue'),
      },
      {
        path: 'recover/sent',
        name: 'PasswordRecoveryEmailSent',
        component: () => import('App/login/components/PasswordRecoveryEmailSent.vue'),
      },
      {
        path: 'new-password',
        name: 'NewPassword',
        component: () => import('App/login/components/NewPassword.vue'),
      },
    ],
  },
];
